import { useEffect, useState } from "react";
import {
  AUTOMATIC_TRANSLATION_NOTICE,
  DEFAULT_LANGUAGE,
  LANGUAGE_OPTIONS,
  ensureGoogleTranslateScript,
  getLanguageLabel,
  markLanguagePromptHandled,
  readGoogleTranslateCookie,
  setGoogleTranslateCookie,
} from "../../lib/language";

function FooterLanguageSwitcher() {
  const [selectedLanguage, setSelectedLanguage] = useState(DEFAULT_LANGUAGE);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    setSelectedLanguage(readGoogleTranslateCookie());
    ensureGoogleTranslateScript();
  }, []);

  const handleChange = (event) => {
    const nextLanguage = event.target.value;
    setSelectedLanguage(nextLanguage);
    setGoogleTranslateCookie(nextLanguage);
    markLanguagePromptHandled();
    window.location.reload();
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <span className="text-xs uppercase tracking-[0.25em] text-white/45">
          Language
        </span>
        <select
          aria-label="Footer language switcher"
          value={selectedLanguage}
          onChange={handleChange}
          translate="no"
          className="notranslate rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm text-white outline-none"
        >
          {LANGUAGE_OPTIONS.map((option) => (
            <option
              key={option.value}
              value={option.value}
              translate="no"
              className="notranslate text-black"
            >
              {getLanguageLabel(option, selectedLanguage)}
            </option>
          ))}
        </select>
      </div>
      <p className="max-w-xs text-xs leading-5 text-white/45">
        {AUTOMATIC_TRANSLATION_NOTICE}
      </p>
    </div>
  );
}

export default FooterLanguageSwitcher;
